import { PRODUCTS_NO_ACTION } from "../../../../../../../constants/productActionTypes.js";
import { AnyObject } from "final-form";
import * as EmailValidator from "email-validator";

export const validation = (values) => {
    const errors: AnyObject = {};

    if (values.actionNotify.isActive) {
        if (!EmailValidator.validate(values.actionNotify.email)) {
            errors.actionNotify = "Email is not valid";
        }
    }

    return errors;
};